import { BrowserRouter, Route, Routes } from "react-router-dom";
import DignosisIntroScreen2 from "./screens/dignosisIntroScreen2/DignosisIntroScreen2";
import Form from "./screens/form/Form";
import WelcomeScreen4 from "./screens/welcome/Welcomescreen4";
import Index from "./screens/body/Index";
import PainDefination from "./screens/painDefination";
import PainLocalization from "./screens/painLocalization";
import DignosisDisclaimer from "./screens/screen8/Dignosisdisclaimer";
import DiagnosisResults from "./screens/DiagnosisResults/DiagnosisResults";
import Treatment from "./screens/Treatment/Treatment";
import TreatmentLoading from "./screens/TreatmentLoading/TreatmentLoading";
import HomeScreen from "./screens/home/HomeScreen";
import Question from "./screens/questions/Question";
import './App.scss';
import Login from "./screens/authentication/Login";
import Signup from "./screens/authentication/Signup";
import SignupInfo from "./screens/authentication/SignupInfo";
import VerifyOtp from "./screens/authentication/otpVerify/VerifyOtp";
import UserAuth from "./screens/UserAuth/UserAuth";
import ForgotPassword from "./screens/authentication/forgotPassword/ForgotPassword";
import UpdatePassword from "./screens/authentication/forgotPassword/UpdatePassword";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Authentication */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/info" element={<SignupInfo />} />
        <Route path="/verifyOtp" element={<VerifyOtp />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/updatePassword" element={<UpdatePassword />} />

        {/* Home Authentication */}

        <Route path="/home/login" element={<Login />} />
        <Route path="/home/signup" element={<Signup />} />
        <Route path="/home/signup/info" element={<SignupInfo />} />
        <Route path="/home/verifyOtp" element={<VerifyOtp />} />
        <Route path="/home/forgotPassword" element={<ForgotPassword />} />
        <Route path="/home/updatePassword" element={<UpdatePassword />} />



        <Route path="/" element={<HomeScreen />}></Route>
        <Route path="/patientForm" element={<Form />}></Route>
        <Route
          path="/dignosisIntro"
          element={<DignosisIntroScreen2 />}
        ></Route>
        <Route path="/welcome" element={<WelcomeScreen4 />}></Route>

        <Route path="/body" element={<Index />}></Route>
        <Route path="/painDefination" element={<PainDefination />}></Route>
        <Route path="/painLocalization" element={<PainLocalization />}></Route>
        <Route path="/questions" element={<Question />}></Route>

        <Route
          path="/importantInformation"
          element={<DignosisDisclaimer />}
        ></Route>
        <Route path="/diagnosis" element={<DiagnosisResults />}></Route>

        <Route path="/treatmentLoading" element={<UserAuth><TreatmentLoading /></UserAuth>}></Route>

        <Route path="/treatment/*" exact={false} element={<UserAuth><Treatment /></UserAuth>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
